import { Loader } from 'shared/components/Loader'
import { StyledLoaderContainer } from './styles'

export const LoaderPreview = () => (
    <StyledLoaderContainer>
        <Loader />
    </StyledLoaderContainer>
)
